<template>
  <SogPage
    id="page"
    title="Lieferungen"
  >
    <SogCard>
      <SogCardActions>
        <SogCardActionButton
          :kind="SogButtonKind.Refresh"
          @click="p_init"
        />
        <SogCardActionButton :kind="SogButtonKind.Back" />
      </SogCardActions>
      <SogCardContent v-show="_orders.length===0">
        Sie haben keine Lieferungen
      </SogCardContent>
      <SogCardContent
        v-for="(item) in _orders"
        :key="item"
      >
        <DeliveryCardComponent
          :order-head="item"
          :order-items="getOrderItems(item.id)"
        >
          <SogCardActions>
            <SogCardActionButton
              mdi-icon="mdi-truck-check"
              tooltip="Bestellung annehmen"
              @click="onDelivery(item)"
            />
          </SogCardActions>
        </DeliveryCardComponent>
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, reactive} from "vue";
import {onBeforeRouteUpdate} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiStore from "@/modules/Store/api";
import {useAccountStore} from "@/stores/accountStore";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import DeliveryCardComponent from "@/modules/Store/components/DeliveryCardComponent.vue";
import OrderHead from "@/shared/model/orderHead";
import OrderItem from "@/shared/model/orderItem";
import notificationService from "@/shared/services/NotificationService";
import apiOrder from "@/modules/Order/api";


const _spinner = useSpinner()
const _accountStore = useAccountStore();
const _orders = reactive<OrderHead[]>([])
const _orderItems = reactive<OrderItem[]>([])

async function p_init() {
  _orders.length = 0;
  _orderItems.length = 0;
  if (!_accountStore.person?.id)
    return
  _spinner.show()
  try {
    const res = await apiStore.listDelivery(_accountStore.person.id)
    if (res?.orderHeads) {
      _orders.push(...res.orderHeads)
    }
    if (res?.orderItems) {
      _orderItems.push(...res.orderItems)
    }
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});


function getOrderItems(id?: string): OrderItem[] {
  return _orderItems.filter(t => t.id == id)
}

async function onDelivery(order?: OrderHead) {
  if (!order?.id)
    return
  try {
    _spinner.show()
    if (await apiOrder.delivery(order.id)) {
      notificationService.success("Bestellung " + order.orderNumber + " wurde angenohmen")
      await p_init();
    }
  } finally {
    _spinner.hide()
  }
}


</script>
<style scoped>
</style>
